import { Component, Input, OnInit } from '@angular/core';
import { InstitucionDenuncia } from 'src/app/model/ReglamentoInterno.model';

@Component({
  selector: 'app-institucion-denuncia-reglamento',
  templateUrl: './institucion-denuncia-reglamento.component.html',
  styleUrls: ['./institucion-denuncia-reglamento.component.css']
})
export class InstitucionDenunciaReglamentoComponent implements OnInit {

  @Input() institucionDenuncia : InstitucionDenuncia;
  @Input() readonly : boolean;
  
  constructor() { }

  ngOnInit(): void {
  }

}
